import React from "react";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from '@material-ui/icons/Info';

export const CInfoIcon = (props) => {
    return(
      <IconButton style={{height:"30px", width:"30px", marginTop:-13}} onClick={props.rm ? ()=>{props.setOpen(true);} : props.setOpen}>< InfoIcon style={{color:"#0079fc", height:"20px", width:"20px"}} /></IconButton>
    );
}